import fullpage from "fullpage.js";

const _mobilebreakpoint = 768;
const heightBreakepoint = 685;
const navbar = document.getElementById("page-header");
const arrowNav = document.querySelector(".arrow-navigation");
let sectionIndex;
let outer;
let isOuterSet = false;

if (arrowNav) {
  changeNavButtons(0);
}

if (document.getElementById("full-page-wrapper")) {
  var myFullpage = new fullpage("#full-page-wrapper", {
    setAllowScrolling: true,
    scrollingSpeed: 600,
    keyboardScrolling: true,
    autoScrolling: true,
    licenseKey: "442D27CF-F2F04E2B-AFFD1CCB-81320165",
    recordHistory: false,
    fitToSection: false,
    lazyLoading: true,
    verticalCentered: false,
    scrollHorizontally: false,
    animateAnchor: true,
    css3: true,
    paddingTop: "0",
    paddingBottom: "0",
    onLeave: function (origin, destination, direction) {
      sectionIndex = direction == "down" ? origin.index + 1 : origin.index - 1;
      setFullPageSticky(sectionIndex);
      changeNavButtons(sectionIndex);
    },
  });
}

function lowHeight() {
  return window.innerHeight < heightBreakepoint;
}

function setFullPageSticky(index) {
  if (navbar) {
    if (_mobilebreakpoint < window.innerWidth || !lowHeight()) {
      if (index === 0) {
        if (navbar.classList.contains("sticky")) {
          navbar.classList.remove("sticky");
          document.body.classList.remove("header-sticky");
        }
      } else {
        if (!navbar.classList.contains("sticky")) {
          navbar.classList.add("sticky");
          document.body.classList.add("header-sticky");
        }
      }
    }
  }
}

function changeNavButtons(index) {
  if (index === 0) {
    arrowNav.classList.add("first-section");
  } else if (index === 5) {
    arrowNav.classList.add("last-section");
  } else {
    if (arrowNav.classList.contains("first-section"))
      arrowNav.classList.remove("first-section");
    if (arrowNav.classList.contains("last-section"))
      arrowNav.classList.remove("last-section");
  }
}

setAutoScroll();

window.addEventListener("load", (event) => {
  setAutoScroll();
  setBgImageOpacity();
});

window.addEventListener("resize", function () {
  setAutoScroll();
  setBgImageOpacity();
});

function setBgImageOpacity() {
  if (
    window.innerWidth > _mobilebreakpoint ||
    window.innerHeight > heightBreakepoint
  ) {
    let img = document.querySelector(".section-1 .background-image img");
    if (img) {
      const setOpacity = (value) => {
        img.style.opacity = value;
      };

      let size = img.clientWidth / window.innerWidth;

      if (size < 0.72) setOpacity(1);
      else if (size < 0.85) setOpacity(0.6);
      else setOpacity(0.35);
    }
  }
}

function setAutoScroll() {
  if (typeof fullpage_api !== "undefined") {
    if (
      window.innerWidth <= _mobilebreakpoint ||
      window.innerHeight < heightBreakepoint
    ) {
      fullpage_api.setResponsive(true);
      Array.from(document.querySelectorAll("section.fp-section")).forEach(
        (section) => {
          section.classList.add("fp-auto-height");
        }
      );
      outer = window.outerHeight;
      isOuterSet = true;
    } else {
      if (isOuterSet === true) {
        if (outer !== window.outerHeight) {
          fullpage_api.setResponsive(false);
          Array.from(document.querySelectorAll("section.fp-section")).forEach(
            (section) => {
              section.classList.remove("fp-auto-height");
            }
          );
        }
      } else {
        fullpage_api.setResponsive(false);
        Array.from(document.querySelectorAll("section.fp-section")).forEach(
          (section) => {
            section.classList.remove("fp-auto-height");
          }
        );
      }
    }
  }
}

function filterMenuItemsByLocation() {
  var mainMenu = document.querySelector("#block-blazingsaddles-main-menu");
  if (!mainMenu) {
    return;
  }

  var currentLocation = document.location.pathname.split("/")[1];
  var allLocations = Array.from(
    document.querySelectorAll(
      "#block-views-block-call-us-menu-block-1-2 .city-name"
    )
  ).map((el) => {
    return el.textContent.toLowerCase().replace(" ", "-");
  });

  if (allLocations.includes(currentLocation)) {
    window.bsLocation = currentLocation;
  } else {
    window.bsLocation = "";
  }

  var mainMenuItems = Array.from(
    document.querySelectorAll("#block-blazingsaddles-main-menu li")
  );
  mainMenuItems.forEach((mainMenuItem) => {
    var menuHref = mainMenuItem
      .querySelector("a")
      .getAttribute("href")
      .split("/")[1];
    if (allLocations.includes(menuHref) && menuHref !== currentLocation) {
      mainMenuItem.parentElement.removeChild(mainMenuItem);
    }
  });
}

window.addEventListener("DOMContentLoaded", (event) => {
  filterMenuItemsByLocation();
});
